import axios from 'axios'
//import LocalStorageService from "./services/storage/localstorageservice";
import router from '../router'
var parse = require('json-parse-safe')

axios.defaults.baseURL = process.env.VUE_APP_API_URL || "http://localhost:3001";

//axios.defaults.baseURL = "https://projeto-onix-dev.web.app/";
//axios.defaults.baseURL = "https://brizolaejapur-backend-api-0ba6563c28db.herokuapp.com/";

// axios.defaults.baseURL = "https://smartpin-backend-api-119d1498f7ca.herokuapp.com/";


// Add a request interceptor
axios.interceptors.request.use(

  config => {
    const data = parse(<any>localStorage.getItem('token'))

    if (data.value) {
      config.headers['Authorization'] = 'Bearer ' + data.value
    }

    const tenantCode = localStorage.getItem('tenant_code')
    if (tenantCode) {
      config.headers['x-tenant-code'] = tenantCode
    }

    config.headers['Access'] = '*'
    config.headers['Access-Control-Request-Method'] = 'GET, OPTIONS, POST, PATCH, PUT, DELETE'
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Headers'] = 'Origin, Content-Type, X-Auth-Token'
    return config
  },
  error => {
    Promise.reject(error)
  }
)



// axios.interceptors.response.use(
//   response => {
//     return response
//   },
//   function(error) {
//     const originalRequest = error.config

//     if (error.request.status == 0) {
//       console.log("erro: ", error)
//       return Promise.reject(error)
//     }

//     if (error.response.status === 401 && !originalRequest.url.includes('/sessions')) {
//       router.push('/login')

//       console.log("erro_401: ", error)
//       return Promise.reject(error)
//     }

//     if (error.response.data && 'success' in error.response.data) {
//       return Promise.reject(error.response.data)
//     }

//     return Promise.reject(error)
//   }
// )


//Add a response interceptor
axios.interceptors.response.use(
  response => {
    return response
  },
  function (error) {
    const originalRequest = error.config

    if (error.request.status == 0) {
      console.log("erro: ", error)
      return Promise.reject(error)

    }

    if (error.response.status === 401 && !originalRequest.url.includes('/sessions')) {
      router.push('/login')

      console.log("erro_401: ", error)
      return Promise.reject(error)
    }

    // if (error.response.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   const token = parse(<any>localStorage.getItem("token"));

    //   return axios
    //     .get(
    //       `/sessions/${token.value.session}/access/new?access=${token.value.access}`
    //     )
    //     .then((res) => {
    //       if (res.status === 200) {
    //         localStorage.setItem("token", JSON.stringify(res.data.data));
    //         axios.defaults.headers.common["Authorization"] =
    //           "Bearer " + res.data.data.access;
    //       }
    //       return axios(originalRequest);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       router.push("/login");
    //       return Promise.reject(error);
    //     });
    // }

    //check error format
    if (error.response.data && 'success' in error.response.data) {
      return Promise.reject(error.response.data)
    }

    return Promise.reject(error)
  }
)
